module.exports = __webpack_public_path__ + "static/media/fk.c63ee1c8.png";